// Athly — Scroll reveal
// Paste into Assets > athly.js  then add <script src="{{ 'athly.js' | asset_url }}" defer></script> in theme.liquid
(function(){
  const obs = new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(e.isIntersecting){ e.target.classList.add('ath-visible'); obs.unobserve(e.target); }
    });
  },{threshold:0.1});
  document.querySelectorAll('.ath-reveal').forEach(el=>obs.observe(el));
})();